import React from "react";
import { AppProvider } from "@context/AppContext";

import GTM from "@utils/GTM";

// Supports weights 200-900
import "@fontsource-variable/nunito";
import "@fontsource-variable/nunito-sans";

import "./src/styles/global.css";
import "./src/styles/cookies.css";

export const onRouteUpdate = () => {
  GTM.reset();
};

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);

export const onServiceWorkerUpdateReady = () => {
  window.location.reload();
};

export const onClientEntry = () => {
  // Simple offline management
  const disableInteractiveElements = () => {
    const interactiveElements = document.querySelectorAll('a[href], button, input, textarea, select, [contenteditable="true"], [role="button"], [role="link"], [role="menuitem"], [role="tab"], [role="option"], [role="checkbox"], [role="radio"], [role="switch"], [role="slider"], [role="spinbutton"], [role="combobox"], [role="listbox"], [role="textbox"], [role="searchbox"], [role="gridcell"], [role="columnheader"], [role="rowheader"], [role="treeitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');

    interactiveElements.forEach(element => {
      if (!element.hasAttribute('data-original-tabindex')) {
        const originalTabindex = element.getAttribute('tabindex');
        if (originalTabindex !== null) {
          element.setAttribute('data-original-tabindex', originalTabindex);
        }
      }

      if (!element.hasAttribute('data-original-aria-hidden')) {
        const originalAriaHidden = element.getAttribute('aria-hidden');
        if (originalAriaHidden !== null) {
          element.setAttribute('data-original-aria-hidden', originalAriaHidden);
        }
      }

      element.classList.add('offline-disabled');
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('tabindex', '-1');
    });
  };

  const enableInteractiveElements = () => {
    const disabledElements = document.querySelectorAll('.offline-disabled');

    disabledElements.forEach(element => {
      element.classList.remove('offline-disabled');

      const originalAriaHidden = element.getAttribute('data-original-aria-hidden');
      if (originalAriaHidden !== null) {
        element.setAttribute('aria-hidden', originalAriaHidden);
        element.removeAttribute('data-original-aria-hidden');
      } else {
        element.removeAttribute('aria-hidden');
      }

      const originalTabindex = element.getAttribute('data-original-tabindex');
      if (originalTabindex !== null) {
        element.setAttribute('tabindex', originalTabindex);
        element.removeAttribute('data-original-tabindex');
      } else {
        element.removeAttribute('tabindex');
      }
    });
  };

  // Check if we're in browser environment
  if (typeof window !== 'undefined') {
    // Handle initial state
    if (!navigator.onLine) {
      disableInteractiveElements();
    }

    // Listen for online/offline events
    window.addEventListener('online', enableInteractiveElements);
    window.addEventListener('offline', disableInteractiveElements);

    if ('serviceWorker' in navigator) {
      // Wait for window load before registering the Service Worker
      window.addEventListener('load', () => {
        // Use setTimeout to delay slightly without using requestIdleCallback
        setTimeout(() => {
          navigator.serviceWorker
            .register('/sw.js')
            .catch((error) => {
              console.error('Service Worker registration failed:', error);
            });
        }, 1);
      });
    }
  }


  try {

    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      // TODO: update this when we have final param after hosting sets up vanity redirect
      const sourceParam = params.get("utm_source") === "getneffynow";
      const mediumParam = params.get("utm_medium") === "vanity-url";
      const termParam = params.get("utm_term")?.startsWith("redirect");
  
      if (sourceParam && mediumParam && termParam) {
        sessionStorage.setItem("showvanityModal", "1");
      } else {
        sessionStorage.removeItem("showvanityModal")
      }
    }
  } catch {}


};

